export default "__VITE_ASSET__2aa8cf95__"